<template>
  <tbe-accordion class="tbe-options" :value="option.id">
    <tbe-option
      v-for="(item, index) in options"
      :index="index"
      :total="options.length"
      :option="item"
      :key="item.id"
    />
  </tbe-accordion>
</template>

<script>
  import { computed, watch } from 'vue'
  import { useStore } from 'vuex'
  import { tbeAccordion } from 'common/plugins/tbe-accordion'

  import useDataLayer, { DATA_LAYER_EVENTS } from '@/hooks/useDataLayer'

  import TbeOption from '@/components/tbeOption'

  export default {
    name: 'tbeOptions',

    components: { tbeAccordion, TbeOption },

    setup() {
      const store = useStore()
      const dataLayer = useDataLayer()

      const option = computed(() => store.state.booking.option)
      const options = computed(() => store.state.booking.options)

      watch(
        option,
        () => {
          if (!option.value) return

          dataLayer.clearEcommerce()
          dataLayer.pushEcommerce(DATA_LAYER_EVENTS.ECOMMERCE.VIEW_ITEM)
        },
        { immediate: true }
      )

      return { option, options }
    }
  }
</script>

<style lang="scss" scoped></style>
